import { EngineType } from 'types/Workflows';

export const ALWAYS_ENABLED_ENGINE_TYPES: EngineType[] = [EngineType.Filetype];

export const isAlwaysEnabledEngineType = (engineType: EngineType) => ALWAYS_ENABLED_ENGINE_TYPES.includes(engineType);

// Aether default workflows: fixed read-only canvases, viewable by everyone but never editable.
export const AETHER_WORKFLOW_IDS = ['aether', 'aether_unarchive'];

export const isAetherWorkflowId = (workflowId?: string) =>
    typeof workflowId === 'string' && AETHER_WORKFLOW_IDS.includes(workflowId.toLowerCase());

// Every default workflow id selectable on the scan surfaces and listed on the Workflows page.
// The underscore-separated tokens double as the scan `rule` string (id.split('_') → 'aether, unarchive').
export const DEFAULT_WORKFLOW_IDS = [
    'multiscan_sanitize_unarchive',
    'multiscan_unarchive',
    'cdr',
    ...AETHER_WORKFLOW_IDS,
];

export const isDefaultWorkflowId = (workflowId?: string) =>
    typeof workflowId === 'string' && DEFAULT_WORKFLOW_IDS.includes(workflowId.toLowerCase());

// Engines reachable from the Aether canvases — their drawers always show status Enabled there.
export const AETHER_ENABLED_ENGINE_TYPES: EngineType[] = [
    EngineType.Filetype,
    EngineType.Extraction,
    EngineType.Filescanio,
    EngineType.General,
];

// Non-Aether default workflows: /default-workflow/rules reports platform_enabled=false on every engine
// (the platform stores no per-engine flags for defaults), so the engines each rule implies are fixed
// here by rule name — same approach as the Aether list above.
const DEFAULT_WORKFLOW_ENABLED_ENGINE_TYPES: Record<string, EngineType[]> = {
    multiscan_unarchive: [EngineType.Metascan, EngineType.Extraction, EngineType.General],
    multiscan_sanitize_unarchive: [EngineType.Metascan, EngineType.Cdr, EngineType.Extraction, EngineType.General],
    cdr: [EngineType.Cdr, EngineType.General],
};

export const getDefaultWorkflowEnabledEngineTypes = (workflowId?: string): EngineType[] | null => {
    if (!workflowId) {
        return null;
    }
    if (isAetherWorkflowId(workflowId)) {
        return AETHER_ENABLED_ENGINE_TYPES;
    }

    return DEFAULT_WORKFLOW_ENABLED_ENGINE_TYPES[workflowId.toLowerCase()] ?? null;
};
